import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
import { MathUtils } from '@shared/utils/MathUtils';
class InstrumentLotsUtils {
    getSortedDefaultLots(defLots, lotSize, precision, isQuantityInLots) {
        const lotValues = new Map();
        const defLotsLen = defLots.length;
        const divider = Math.pow(10, precision);
        for (let i = 0; i < defLotsLen; i++) {
            const selectiveLot = defLots[i];
            let convValue = Number.parseFloat(selectiveLot.Lots);
            if (!isQuantityInLots) {
                convValue *= lotSize;
            }
            // обрезаем без округления дробную часть числа, которая выходит за пределы DecimalPlaces
            let dConvValue = MathUtils.trunc(convValue * divider) / divider;
            // Js float calc fix.
            dConvValue = Number.parseFloat(dConvValue.toFixed(precision));
            if (!selectiveLot.Selected || lotValues.has(dConvValue)) {
                continue;
            }
            lotValues.set(dConvValue, true);
        }
        // Populating dropdown by instrument's default lots values.
        const sortedLots = Array.from(lotValues.keys());
        sortedLots.sort((a, b) => a - b);
        return sortedLots;
    }
    formatLotValue(lot, ins) {
        return MathUtils.formatValueWithEps(InstrumentUtils.formatAmountValue(lot, ins));
    }
}
export const instrumentLotsUtils = new InstrumentLotsUtils();
